module.exports = __webpack_public_path__ + "static/media/lepes4.29256197.png";